module.exports = __webpack_public_path__ + "img/mtn-mobile-money-logo.0b5f84f3.png";